import * as Types from '../../types.generated';

import { gql } from '@apollo/client';
export type CreateAiCourseResultFragment = { __typename?: 'Course', id: number, draftVersion: { __typename?: 'CourseVersion', id: number }, libraryItem: { __typename?: 'LibraryItem', id: string } };

export const CreateAiCourseResultFragmentDoc = gql`
    fragment CreateAICourseResult on Course {
  id
  draftVersion {
    id
  }
  libraryItem {
    id
  }
}
    `;